module.exports = __webpack_public_path__ + "img/img21.ca9b110a.svg";